export default {"src":"/_next/static/media/avalanche.9d53cbf0.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};